import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './ProductsPmsHeader.css';

function ProductsBeHeader() {
    const { t } = useTranslation();

    return (
        <div className='product-header' style={{ backgroundImage: 'url(/images/products-be-header.png)' }}>
            <div className='page-content d-flex align-items-center'>
                <div className='col-6 d-flex flex-column'>
                    <div className='chip-green'>
                        {t('Direct Bookings, Maximum Control')}
                    </div>
                    <h1>{t('Hotel Booking Engine & Online Hotel Reservation System - Boost Direct Revenue')}</h1>
                    <p className='body-large'>
                        {t('Engineered for lightning speed, flexibility, and personalization, our hotel booking engine and online hotel reservation system syncs in real time with your PMS and channel manager, delivering a friction-free booking experience for guests and staff on any device.')}
                    </p>
                </div>
                <div className='col img-wrapper'>
                    <img src='/images/bookingengineheader.svg' alt={"Room planning"}/>
                </div>
            </div>
        </div>
    );
}

export default ProductsBeHeader;
